<template>
    <div class="px-auto">
        <page-title :title="$t('localServer.title')" :showTitle="false"></page-title>
        <!-- <div class="card">
            <div class="card-body">
                <h5 class="card-title">{{ $t('localServer.version') }}</h5>

                <div class="card-text">
                    <h5 aria-describedby="serverDetails">Локален сървър за достъп до електронни сертификати <span class="badge badge-light">1.0.1</span></h5>
                    <p class="form-text text-muted" id="serverDetails">
                        Поддържа се <i class="fab fa-windows"></i> Windows
                        версия 7 и по-нова
                    </p>
                </div>
                <a class="card-link"
                    type="download"
                    href="/download/LocalServer_NEISPUO_1.0.1.exe"
                >
                    <i class="fas fa-download"></i>
                    {{$t('buttons.download.btnText')}}
                </a>
            </div>
        </div> -->

        <div class="loader" v-show="loadingCheck"></div>
        <div class="card my-2" v-show="!loadingCheck">
            <div class="card-body">
                <h5 class="card-title">{{ $t('localServer.currentInstalation') }}</h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ $t('localServer.currentInstalationDescription') }}</h6>

                <div class="card-text">
                    <table class="table table-responsive">
                        <tbody>
                            <tr>
                                <td>{{ $t('localServer.version') }}</td>
                                <td>{{ version }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('localServer.type') }}</td>
                                <td>{{ edition }}</td>
                            </tr>
                             <tr>
                                <td>{{ $t('localServer.ability') }}</td>
                                <td>{{ caps }}</td>
                            </tr>
                             <tr>
                                <td>{{ $t('localServer.settings') }}</td>
                                <td>{{ settings }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <button class="btn btn-primary"
                    type="button"
                    @click.stop="checkInstallation"
                >
                    <i class="fas fa-sync"></i>
                    {{$t('localServer.check')}}
                </button>
            </div>
        </div>

        <div class="loader" v-show="loadingSign"></div>
        <div class="card my-2" v-show="!loadingSign">
            <div class="card-body">
                <h5 class="card-title">{{ $t('localServer.instalationCheck') }}</h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ $t('localServer.instalationCheckDescription') }}</h6>


                <div class="card-text">
                    <table class="table table-responsive">
                        <tbody v-if="signature">
                            <tr>
                                <td>{{ $t('localServer.data') }}</td>
                                <td><pre>{{ signature.contents }}</pre></td>
                            </tr>
                            <tr>
                                <td>{{ $t('localServer.message') }}</td>
                                <td>{{ signature.message }}</td>
                            </tr>
                             <tr>
                                <td>{{ $t('localServer.addData') }}</td>
                                <td>{{ signature.additionalInformation }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <button class="btn btn-primary"
                    type="button"
                    @click.stop="signXml"
                >
                    <i class="fas fa-signature"></i>
                    {{$t('signing.sign')}}
                </button>
                <button class="btn btn-success"
                    type="button"
                    @click.stop="signTestPdf"
                >
                    <i class="fas fa-signature"></i>
                    Sign test pdf
                </button>
                <button class="btn btn-info"
                    type="button"
                    @click.stop="signTestDocx"
                >
                    <i class="fas fa-signature"></i>
                    Sign test docx
                </button>

                <hr />

                <div class="row mt-2">
                    <div class="col-md-5 form-group">
                        <label class="font-weight-bold">{{ $t('localServer.parseSource') }}</label>
                        <input class="form-control"
                            type="text"
                            v-model="parseSource"
                        />
                    </div>
                    <div class="col-md-2 form-group">
                        <button class="btn btn-secondary"
                            type="button"
                            @click.stop="tryParsePdfBookmark"
                        >
                            Прочитане на координати
                        </button>
                    </div>
                    <div class="col-md-5 form-group">
                        <label class="font-weight-bold">{{ $t('localServer.parseResult') }}</label>
                        <json-formatter
                            v-if="parseResult"
                            :data="parseResult"
                            path="res"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="card my-2" v-if="hasSigningAdministrationReadPermission">
            <div class="card-body">
                <h5 class="card-title">Настройки по подразбиране на приложението</h5>

                <div class="card-text">
                    <json-formatter
                        v-if="appSigningSettings"
                        :data="appSigningSettings"
                        path="res"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle';
import localServerService from '@/services/localServer.service';
import certificateService from '@/services/certificate.service';
import signService from '@/services/sign.service';
import JsonFormatter from 'vue-json-pretty';
import { mapGetters } from 'vuex';

export default {
    name: 'LocalServerView',
    components: {
        PageTitle,
        JsonFormatter
    },
    data() {
        return {
            version: "няма връзка",
            edition: "няма връзка",
            caps: "няма връзка",
            settings: "няма връзка",
            xml: "<isupo><data></data></isupo>",
            signature: null,
            loadingCheck: false,
            loadingSign: false,
            parseSource: null,
            parseResult: null
        };
    },
    computed: {
        ...mapGetters(['claims', 'appSigningSettings']),
        hasSigningAdministrationReadPermission() {
            return this.claims.signingAdministration.read;
        }
    },
    mounted() {
        this.checkInstallation();
    },
    methods: {
        async checkInstallation() {
            this.loadingCheck = true;

            await localServerService.version()
                .then((data) => {
                    this.version = data.data;
                })
                .catch((error) => {
                    this.version = error;
                });

            await localServerService.edition()
                .then((data) => {
                    this.edition = data.data;
                })
                .catch((error) => {
                    this.edition = error;
                });

            await localServerService.capabilities()
                .then((data) => {
                    this.caps = data.data;
                })
                .catch((error) => {
                    this.caps = error;
                });

            await localServerService.settings()
                .then((data) => {
                    this.settings = data.data;
                })
                .catch((error) => {
                    this.settings = error;
                });

            this.loadingCheck = false;
        },
        signXml() {
            this.loadingSign = true;
            this.signature = null;

            certificateService.signXml(this.xml)
                .then((response) => {
                    this.signature = response.data;
                })
                .catch((error) => {
                    this.signature = { isError: true, message: error.message };
                })
                .then(() => {
                    this.loadingSign = false;
                });
        },
        signTestPdf() {
            this.loadingSign = true;

            signService.signTestPdf()
                .then((response) => {
                    console.log(response);

                    const blob = signService.b64toBlob(response.data.content, response.data.contentType);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.data.name); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                     console.log(error);
                })
                .then(() => {
                    this.loadingSign = false;
                });
        },
        signTestDocx() {
            this.loadingSign = true;

            signService.signTestDocx()
                .then((response) => {
                    console.log(response);

                    const blob = signService.b64toBlob(response.data.content, response.data.contentType);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.data.name); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                     console.log(error);
                })
                .then(() => {
                    this.loadingSign = false;
                });
        },
        tryParsePdfBookmark() {
            this.loadingSign = true;

            signService.tryParsePdfBookmark({ contents: this.parseSource })
                .then((response) => {
                    this.parseResult = response;
                })
                .catch((error) => {
                     console.log(error);
                })
                .then(() => {
                    this.loadingSign = false;
                });
        }
    }
};
</script>
